import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import MyRouter from './Router';
import * as serviceWorker from './serviceWorker';
//init React-dates
import 'react-dates/initialize';
//多國語系
import { IntlProvider } from 'react-intl';
import { flattenMessages } from './utils';
//在專案加入FAS icon
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas);

const Root = (props) => {
  // 取 session 的語系
  let sessionLang = sessionStorage.getItem('lang');
  // 使用 useState 定義 locale 這個 state
  const [locale, setLocale] = useState(sessionLang || 'zh');

  let messages;
  let policy_messages;
  // 根據使用者選擇的語系 locale 切換使用不同的 messages
  if (locale.includes('zh')) {
    messages = props.lang.zh;
    policy_messages = props.lang.policy_zh;
  } else if (locale.includes('en')) {
    messages = props.lang.en;
    policy_messages = props.lang.policy_en;
  }
  return (
    <IntlProvider locale={locale} key={locale} messages={flattenMessages(messages)}>
      <MyRouter config={props.config} setLocale={setLocale} locale={locale} policy_messages={policy_messages} messages={messages}/>
    </IntlProvider>
  );
};

window.RenderApp = function (config, lang) {
  new ReactDOM.render(<Root config={config} lang={lang} />, document.getElementById('root'));
}

serviceWorker.unregister();
